import { classMap as w } from "lit/directives/class-map.js";
import { ifDefined as U } from "lit/directives/if-defined.js";
import { unsafeHTML as T } from "lit/directives/unsafe-html.js";
import { unsafeStatic as D, literal as I, html as i } from "lit/static-html.js";
import { getCustomElementSuffix as q } from "../../api/custom-element-scope.js";
import { highlightTextMultiple as V, highlightText as z } from "../../api/marker/marker.js";
const x = I`dss-icon${D(q())}`, F = I`dss-spinner${D(q())}`, H = (s) => {
  var f;
  return (f = s.elements) == null ? void 0 : f.map((e, r) => {
    var E, _;
    const g = (e.label ?? "").trim().replace(/\s+/g, "-"), S = (e.value ?? "").trim().replace(/\s+/g, "-"), b = `selector-${g}-${S}`, l = s._valueIsSelected(e.value), u = s.tick && !s.multiple, v = w({
      disabled: s.disabled,
      "dss-disabled": s.disabled,
      "dss-form-field": !0,
      "dss-form-field--simple": s.tick && !s.multiple,
      "dss-form-field--multiple": s.multiple,
      "dss-form-field--readonly": s.readonly,
      "dss-form-field--no-tick": !s.tick,
      "dss-type--default": s.type === "default",
      "dss-type--green": s.type === "green",
      "dss-ticked": u,
      "dss-selected": l && u,
      "dss-form-field--selected": l,
      "dss-first-unselected": r && r > 0 && r === s.selectedCounter,
      "dss-form-field--match": ((E = e.label) == null ? void 0 : E.toLowerCase()) === ((_ = s.filter) == null ? void 0 : _.toLowerCase())
    }), k = w({
      "dss-checkbox": s.multiple,
      "dss-radio": !s.multiple,
      "dss-disabled": s.disabled,
      hidden: u
    }), h = i`
      <input
        id="${b}"
        name="${b}"
        type="checkbox"
        class="${k}"
        .value="${e.value}"
        .checked="${l}"
        @focus="${s._focusEvent}"
        @blur="${s._blurEvent}"
        ?disabled="${s.disabled || s.readonly}"
      />
      <div class="dss-check-overlay"></div>
    `, d = i`<span
      class="dss-icon--checked"
      style="visibility: ${s.isOpen && u && l ? "visible" : "hidden"}"
    ></span>`;
    return i`
      <div
        class="${v}"
        @keydown="${(a) => {
      var A, p, L, C;
      if (a.key === "Enter" || a.key === " ")
        s._manuallySelect(a, e.value);
      else if (a.key === "ArrowUp") {
        const y = a.target, $ = (p = (A = y == null ? void 0 : y.closest(".dss-form-field")) == null ? void 0 : A.previousElementSibling) == null ? void 0 : p.querySelector("input");
        $ == null || $.focus();
      } else if (a.key === "ArrowDown") {
        const y = a.target, $ = (C = (L = y == null ? void 0 : y.closest(".dss-form-field")) == null ? void 0 : L.nextElementSibling) == null ? void 0 : C.querySelector("input");
        $ == null || $.focus();
      }
    }}"
        @click="${(a) => {
      s._manuallySelect(a, e.value);
    }}"
        data-label="${e.label}"
      >
        ${h}
        <label for=${b}>
          ${s.advancedFilter ? T(V(e.label, s.filter || "", s.searchThreshold)) : T(z(e.label, s.filter || ""))}
        </label>
        ${d}
      </div>
    `;
  });
}, O = (s) => {
  var f;
  return (f = s._elementSelectAll) == null ? void 0 : f.map((e) => {
    var b;
    const r = w({
      disabled: s.disabled || s.readonly,
      "dss-form-field": !0,
      "dss-type--default": s.type === "default",
      "dss-type--green": s.type === "green",
      "dss-selectAll": !0,
      "dss-disabled": s.disabled || s.readonly,
      "dss-form-field--match": e.toLowerCase() === ((b = s.filter) == null ? void 0 : b.toLowerCase())
    }), o = w({
      "dss-checkbox": s.multiple
    }), g = i`
      <input
        id="${s._elementId}"
        name="${s._elementId}"
        type="checkbox"
        class="${o}"
        .value="${e}"
        .checked="${s._isAllSelected}"
        @focus="${s._focusEvent}"
        @blur="${s._blurEvent}"
        ?disabled="${s.disabled || s.readonly}"
      />
      <div class="dss-check-overlay"></div>
    `;
    return i`
      <div
        class="${r}"
        @keydown="${(l) => {
      var u, v, k, h;
      if (l.key === "Enter" || l.key === " ")
        s._manuallySelectAll(l);
      else if (l.key === "ArrowUp") {
        const d = l.target, c = (v = (u = d == null ? void 0 : d.closest(".dss-form-field")) == null ? void 0 : u.previousElementSibling) == null ? void 0 : v.querySelector("input");
        c == null || c.focus();
      } else if (l.key === "ArrowDown") {
        const d = l.target, c = (h = (k = d == null ? void 0 : d.closest(".dss-form-field")) == null ? void 0 : k.nextElementSibling) == null ? void 0 : h.querySelector("input");
        c == null || c.focus();
      }
    }}"
        @click="${(l) => {
      s._manuallySelectAll(l);
    }}"
        data-label="${e}"
      >
        ${g}
        <label for="${s._elementId}">${e}</label>
      </div>
    `;
  });
}, Q = (s) => {
  let t = H(s);
  const f = O(s);
  s.multiple && s.selectAll && (t == null || t.unshift(f[0]), t = (t == null ? void 0 : t.length) === 1 ? [] : t);
  const e = (r) => {
    (r.key === "ArrowDown" || r.key === "ArrowUp") && r.preventDefault();
  };
  return i`
    ${s.elements && s.elements.length > 0 ? i`
        <div
          aria-label="${U(s.ariaLabel)}"
          part="selector"
          class="list dss-selector-list-wrapper ${s.boxShadow ? "dss-selector-list-wrapper--box-shadow" : ""}"
          @keydown=${e}
          style="${s._style}"
        >
          ${t}
        </div>
      ` : i`
        <div
          part="selector"
          class="list dss-selector-list-wrapper"
          @keydown=${e}
          style="${s._style}"
        >
          ${s.filter && s.filter.length >= s.filterThreshold ? i`
                <div class="dss-selector-empty">
                  <${x} icon="info" size="sm"></${x}>
                  <span class="text">
                    ${s.filter || s.filter === "" ? i` ${s.emptySelectorLabel}: ${s.filter} ` : i`${s.emptyFilterLabel}`}
                  </span>
                </div>
              ` : i`
                <div class="dss-selector-empty">
                  <${F} size="md"/>
                </div>
              `}
        </div>
      `}
  `;
};
export {
  Q as template
};
//# sourceMappingURL=form-select-options.template.js.map
